import { useTranslation } from 'react-i18next'
import {
  Container,
  Link,
  PolicyPrivacyContainer,
  StyledCopyRight,
  StyledGeneralMenu,
  StyledLinkText,
  StyledWrapper,
} from './styled'
import { useContext, useEffect, useState } from 'react'
import { PoliticsContext } from 'common/contexts/Politics/PoliticsContext'
import { baseURL, REST_ID, TRestaurantData } from 'models'
import axios from 'axios'
import { LoadingWrapperApps } from '../LoadingWrapperApps'
import { useGetRestaurants } from 'common/hooks/useGeRestaurants/useGeRestaurants'

export const General = () => {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const { isOpen, setIsOpen, setPolitics } = useContext(PoliticsContext)
  const { restaurant } = useGetRestaurants()

  isOpen
    ? (document.body.style.overflow = 'hidden')
    : (document.body.style.overflow = 'inherit')

  const handleOpenModalAgreement = () => {
    setIsOpen(!isOpen)
    setName('')
  }

  const handleOpenModalPolitics = () => {
    setIsOpen(!isOpen)
    setName('privacyPolicy')
  }

  const fetchPolitics = async (currentName: string) => {
    try {
      await axios
        .get(`${baseURL}/api/variables/${currentName}`)
        .then(response => setPolitics(response.data))
    } catch (e) {
      throw Error
    }
  }

  useEffect(() => {
    if (name !== '') {
      fetchPolitics(name)
    } else {
      restaurant?.userAgreement && setPolitics(restaurant?.userAgreement)
    }
  }, [name, isOpen, restaurant])

  return (
    <>
      <Container>
        <StyledWrapper>
          <StyledGeneralMenu />
          <LoadingWrapperApps />
        </StyledWrapper>

        <PolicyPrivacyContainer>
          <Link onClick={handleOpenModalAgreement}>
            <StyledLinkText>{t('general.policy.privacy')}</StyledLinkText>
          </Link>
          <Link onClick={handleOpenModalPolitics}>
            <StyledLinkText>{t('policy.privacy')}</StyledLinkText>
          </Link>
          <StyledCopyRight />
        </PolicyPrivacyContainer>
      </Container>
    </>
  )
}
